export default __webpack_public_path__ + "static/media/info.3b2554b2.svg";